import React from "react";
import { Product } from "~/common/Store/models/ProductListing";
import { anyGroupMembersInStock } from "../logic";
import GroupingSelect from "../GroupingSelect";
import { ProductListingView } from "..";

interface GroupingSelectWrapperProps {
  groupingValue: string;
  handleGroupingChange: (
    event: React.ChangeEvent<HTMLSelectElement | HTMLInputElement>,
  ) => void;
  isCarouselProductBox: boolean;
  isCompareWithProductBox: boolean;
  isOnCompareProductsPage: boolean;
  isVirtualItem: boolean;
  product: Product;
  productListingView?: ProductListingView;
}

const GroupingSelectWrapper = ({
  groupingValue,
  handleGroupingChange,
  isCarouselProductBox,
  isCompareWithProductBox,
  isOnCompareProductsPage,
  isVirtualItem,
  product,
  productListingView,
}: GroupingSelectWrapperProps) => {
  const { grouping, groupingAttributes } = product;

  return (
    <>
      {grouping &&
        anyGroupMembersInStock(groupingAttributes) &&
        !isVirtualItem && (
          <GroupingSelect
            {...{
              product,
              groupingValue,
              handleGroupingChange,
              isCompareWithProductBox,
              productListingView,
              isCarouselProductBox,
              isOnCompareProductsPage,
            }}
          />
        )}
    </>
  );
};

export default GroupingSelectWrapper;
